import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

export default {
  ChangePwd(data) {
  return new Promise((resolve, reject) => {
      useHttp()
        .request(httpApi.ChangePwd, data)
        .then(res => {
          resolve(res)
        })
        .catch(err => {
          //ShowErrorList(err.data.Messages)
          reject(err)
        })
    })
  }
}
